module.exports = __webpack_public_path__ + "img/loadingInfo.b4499892.png";